import { Box, Typography } from '@mui/material'
import styles from './GazeEye.module.css';

function GazeEye({currentXPos, currentYPos, eye}) {

    const calculateOffset = (eyePosition, axis) => {
    const maxOffset = axis === 'x' ? 150 / 2 - 20 / 2 : 60 / 2 - 20 / 2; // Different maxOffset for x and y
    return (eyePosition / 0.5) * maxOffset;
  };

  return (
        <div className={styles.gazeEyeContainer}>
          <Typography>x: {currentXPos}</Typography>
          <Typography>y: {currentYPos}</Typography>
          <Typography>{`${eye} Eye`}</Typography>
          <div className={styles.gazeEye}>
            <div className={styles.gazeEyeBorder}></div>
            <Box
              position="absolute"
              bgcolor="black"
              width={20}
              height={20}
              borderRadius="50%"
              top="50%"
              left="50%"
              style={{
                transform: `translate(${calculateOffset(currentXPos, 'x') - 10}px, ${calculateOffset(currentYPos, 'y') - 10}px)`,
              }}
            />
         </div>
        </div>
  )
}

export default GazeEye